import React, { useEffect, useState } from "react";
import { Space, List, Button, Col, Row, Table, Popconfirm, Typography ,Card} from "antd";
import { useNavigate } from "react-router";
import ProductOptionService from "services/product_option";
import { useApp } from "../../contexts/app";
const { Text } = Typography;
const service = new ProductOptionService();

const ProductOption = () => {
  let navigate = useNavigate();
  const [data, setData] = useState([]);
  const [listDetail, setDetail] = useState([]);
  // const [curSelected, setcurSelected] = useState();
  const { prompt } = useApp();
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    var list = await service.list();
    setData(list);
  };

  useEffect(() => {
  
  }, [data])


  const handleDelete = async (parentid, id) => {

    await service.deleteValue({ id: id, parent_id: parentid });
    loadData();
  };

  const handlDeleteParent = async (id) => {

    await service.delete(id);

    loadData();
    setDetail([]);
  }

  const addNew = () => {
    prompt({
      title: "Thêm mới thuộc tính", label: "Nhập Tên",
      onOk: async (text) => {
        const service = new ProductOptionService();

        await service.create({ title: text });
        loadData();
      }
    });
  }


  const editOption = (option) => {
    prompt({
      title: "Sửa thuộc tính", label: "Nhập Tên", value: option.title,
      onOk: async (text) => {
        const service = new ProductOptionService();

        await service.update({ title: text, id: option.id });
        loadData();
      }
    });
  }


  const addNewValue = (id) => {
    prompt({
      title: "Thêm mới giá trị", label: "Nhập Tên",
      onOk: async (text) => {
        const service = new ProductOptionService();
        await service.createValue({ title: text, parent_id: id });
        loadData();

      }
    });
  }






  const editValue = (item, parent_id) => {

    prompt({
      title: "Sửa giá trị", label: "Nhập Tên", value: item.title,
      onOk: async (text) => {
        const service = new ProductOptionService();

        await service.updateValue({ title: text, id: item.id, parent_id:parent_id });
        loadData();

      }
    });
  }

  // const data = [
  //   {
  //     key: '1',
  //     name: 'John Brown',
  //     age: 32,
  //     address: 'New York No. 1 Lake Park',
  //     tags: ['nice', 'developer'],
  //   },
  //   {
  //     key: '2',
  //     name: 'Jim Green',
  //     age: 42,
  //     address: 'London No. 1 Lake Park',
  //     tags: ['loser'],
  //   },
  //   {
  //     key: '3',
  //     name: 'Joe Black',
  //     age: 32,
  //     address: 'Sydney No. 1 Lake Park',
  //     tags: ['cool', 'teacher'],
  //   },
  // ];



  return (
    <>




      <Table
        dataSource={data}
        rowKey={"id"}
        columns={[

          {
            title: "Thuộc tính",
            render: (_, record) => {
              return <div>{record.title}</div>
            }
          },

          {
            title: (<Button

              onClick={addNew}
            >
              Thêm mới thuộc tính
            </Button>),
            render: (_, record) => {
              return (
                <Space>

                  <Button
                    type="link"
                    onClick={(e) =>
                      editOption(record)
                    }
                  >
                    Chỉnh sửa
                  </Button>
                  {record.id != "default" &&

                    <Popconfirm
                      title="Xóa thuộc tính con"
                      description="Bạn có muốn xóa thuộc tính này ?"
                      okText="Có"
                      cancelText="Không"
                      onConfirm={() => handlDeleteParent(record.id)}
                    >
                      <Button color="danger" variant="link">
                        Xóa
                      </Button>
                    </Popconfirm>
                  }

                </Space>
              )
            }
          },

        ]}


        expandable={{
          expandedRowRender: record => {
       
            return (
              <Card>


                <Table columns={
                  [

                    {
                      title: "Phân loại",
                      dataIndex: "title",
                      key: "title",
                    },
                    {
                      title: (
                        <div>
                          <Button type="link" onClick={e => addNewValue(record.id)}>
                            Thêm mới giá trị
                          </Button>
                        </div>
                      ),
                      key: "action",
                      width: "10%",
                      render: (_, record2) => (
                        <Space size="middle">
                          <Button
                            type="link"
                            onClick={(e) => {
                              editValue(record2, record.id )
                            }

                            }
                          >
                            Chỉnh sửa
                          </Button>
                          <Popconfirm
                            title="Xóa thuộc tính"
                            description="Bạn có muốn xóa thuộc tính này ?"
                            okText="Có"
                            cancelText="Không"
                            onConfirm={() => handleDelete(record.id, record2.id)}
                          >
                            <Button color="danger" variant="link">
                              Xóa
                            </Button>
                          </Popconfirm>
                        </Space>
                      ),
                    },
                  ]
                } dataSource={record.values} />
              </Card>
            )
          },



        }}

      >

      </Table>



    </>
  );
};
export default ProductOption;
